 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-03b202f8":"ef4cbb5d","chunk-1438f5ec":"4369971b","chunk-19bd66b2":"aec47862","chunk-2d0a3596":"c9cfc063","chunk-2d0a4478":"62598849","chunk-2d0a47e0":"d190de3f","chunk-2d0a4b20":"6a5d44c6","chunk-2d0b1f84":"5bc0d760","chunk-2d0b2d29":"fdbbf9b1","chunk-2d0c4d85":"1d9d878a","chunk-0f506ebe":"ae4a22a3","chunk-10719a58":"79fe7211","chunk-e72ff10a":"e63cac1a","chunk-ecfa94d8":"e9a27870","chunk-16d3d0f6":"9e4811ea","chunk-2d0c7ca9":"382efacd","chunk-38fe1b4c":"c12ebc4c","chunk-42a50942":"6c154199","chunk-c80ee128":"5b049102","chunk-d42f03d6":"dd6b581d","chunk-fbefe3ba":"c732e17c","chunk-fca76dfa":"1391a073","chunk-1e1ecbec":"11aabac7","chunk-0cce0940":"01ca5746","chunk-2dc205d5":"77e0eb75","chunk-388f6fdf":"c5435112","chunk-38f848c3":"627a4b64","chunk-5d6f0480":"65851e53","chunk-92b5c4e8":"77b42bc0","chunk-a03d730e":"9996d330","chunk-2d0b90b4":"0671dac4","chunk-0013a3cf":"e66ebc7d","chunk-51238ace":"57702a83","chunk-5a2c12db":"6b14cff8","chunk-2d0c53bb":"048e0fa2","chunk-2d0c85d9":"fb721dfe","chunk-2d0c90fc":"06eea1b8","chunk-2d0ce755":"65f8ab14","chunk-2d0d0219":"e3df31f6","chunk-2d0e2742":"5dad1f1d","chunk-2d0e5b74":"b71548dd","chunk-2d0f0bc5":"a3cb24f5","chunk-2d0f1574":"551b89f1","chunk-2d20847f":"ce057b7d","chunk-2d209b43":"4a1141af","chunk-2d210c47":"3eeb68e7","chunk-2d212b1d":"d4c21e13","chunk-2d221e01":"96f2c34b","chunk-2d22fd16":"c0ad9fcb","chunk-2d230115":"f757c613","chunk-2d23028a":"c34cc9e3","chunk-2f6fe07e":"ed6359c5","chunk-30d51d72":"894e0343","chunk-321fb378":"b72c7ce9","chunk-33ef095c":"57304bf2","chunk-7ca651b5":"124b01e6","chunk-b948daca":"e7e99c1c","chunk-d3b0b26c":"e998f9be","chunk-e9200272":"098e145f","chunk-eee7cf9e":"0acd6180","chunk-fb54fa2e":"23f2d3b8","chunk-4f3504bd":"4e0863c1","chunk-2d0cf2d6":"e61b2818","chunk-4eaa901d":"e63f97ae","chunk-647f369e":"c1b979f0","chunk-bf1cb0b0":"e95e3ada","chunk-fef1189a":"4c9a08d4","chunk-2d0abc10":"9f6bd388","chunk-2d0ac931":"f4e0ee0c","chunk-2d0c211b":"20162011","chunk-2d0cf315":"e659bcff","chunk-2d217def":"9b86ebe8","chunk-2d21a9aa":"bdd6764c","chunk-2d222cca":"b8e77524","chunk-2d22895d":"523925f4","chunk-2d23721e":"f4233577","stencil-polyfills-css-shim":"b85f8bdc","stencil-polyfills-dom":"6e9caa76"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-03b202f8":1,"chunk-1438f5ec":1,"chunk-19bd66b2":1,"chunk-0f506ebe":1,"chunk-10719a58":1,"chunk-e72ff10a":1,"chunk-ecfa94d8":1,"chunk-38fe1b4c":1,"chunk-42a50942":1,"chunk-c80ee128":1,"chunk-d42f03d6":1,"chunk-fbefe3ba":1,"chunk-0cce0940":1,"chunk-2dc205d5":1,"chunk-388f6fdf":1,"chunk-38f848c3":1,"chunk-5d6f0480":1,"chunk-92b5c4e8":1,"chunk-a03d730e":1,"chunk-0013a3cf":1,"chunk-51238ace":1,"chunk-5a2c12db":1,"chunk-2f6fe07e":1,"chunk-30d51d72":1,"chunk-33ef095c":1,"chunk-7ca651b5":1,"chunk-b948daca":1,"chunk-d3b0b26c":1,"chunk-e9200272":1,"chunk-eee7cf9e":1,"chunk-fb54fa2e":1,"chunk-4f3504bd":1,"chunk-4eaa901d":1,"chunk-647f369e":1,"chunk-bf1cb0b0":1,"chunk-fef1189a":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-03b202f8":"2cd2bd7b","chunk-1438f5ec":"146171d1","chunk-19bd66b2":"1dd2b88f","chunk-2d0a3596":"31d6cfe0","chunk-2d0a4478":"31d6cfe0","chunk-2d0a47e0":"31d6cfe0","chunk-2d0a4b20":"31d6cfe0","chunk-2d0b1f84":"31d6cfe0","chunk-2d0b2d29":"31d6cfe0","chunk-2d0c4d85":"31d6cfe0","chunk-0f506ebe":"013a209e","chunk-10719a58":"2896ec2e","chunk-e72ff10a":"d87376b8","chunk-ecfa94d8":"86be7e8d","chunk-16d3d0f6":"31d6cfe0","chunk-2d0c7ca9":"31d6cfe0","chunk-38fe1b4c":"013a209e","chunk-42a50942":"0a26f220","chunk-c80ee128":"f619a0f2","chunk-d42f03d6":"94a11c03","chunk-fbefe3ba":"f297ec7e","chunk-fca76dfa":"31d6cfe0","chunk-1e1ecbec":"31d6cfe0","chunk-0cce0940":"9c9e0ce4","chunk-2dc205d5":"1c40be8a","chunk-388f6fdf":"4faddb04","chunk-38f848c3":"2388e731","chunk-5d6f0480":"8682220d","chunk-92b5c4e8":"112b5ea3","chunk-a03d730e":"c2221387","chunk-2d0b90b4":"31d6cfe0","chunk-0013a3cf":"97b1e3c9","chunk-51238ace":"a6bb156b","chunk-5a2c12db":"cadea714","chunk-2d0c53bb":"31d6cfe0","chunk-2d0c85d9":"31d6cfe0","chunk-2d0c90fc":"31d6cfe0","chunk-2d0ce755":"31d6cfe0","chunk-2d0d0219":"31d6cfe0","chunk-2d0e2742":"31d6cfe0","chunk-2d0e5b74":"31d6cfe0","chunk-2d0f0bc5":"31d6cfe0","chunk-2d0f1574":"31d6cfe0","chunk-2d20847f":"31d6cfe0","chunk-2d209b43":"31d6cfe0","chunk-2d210c47":"31d6cfe0","chunk-2d212b1d":"31d6cfe0","chunk-2d221e01":"31d6cfe0","chunk-2d22fd16":"31d6cfe0","chunk-2d230115":"31d6cfe0","chunk-2d23028a":"31d6cfe0","chunk-2f6fe07e":"bde67799","chunk-30d51d72":"43584a2b","chunk-321fb378":"31d6cfe0","chunk-33ef095c":"013a209e","chunk-7ca651b5":"ef5f42db","chunk-b948daca":"8e4ca08e","chunk-d3b0b26c":"7308ecae","chunk-e9200272":"02ec4705","chunk-eee7cf9e":"3ed9b54e","chunk-fb54fa2e":"04f7f7ee","chunk-4f3504bd":"ed767b45","chunk-2d0cf2d6":"31d6cfe0","chunk-4eaa901d":"65e5bb00","chunk-647f369e":"fed70f2c","chunk-bf1cb0b0":"dc694a12","chunk-fef1189a":"2b883fc3","chunk-2d0abc10":"31d6cfe0","chunk-2d0ac931":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d23721e":"31d6cfe0","stencil-polyfills-css-shim":"31d6cfe0","stencil-polyfills-dom":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
